export const DEFAULT_CURRENCY = 'USD';
export const DEFAULT_LOCALE = 'en-US';

export const SELECTED_CURRENCY_STORAGE_KEY = 'atemoya-app:selected-currency';
export const SELECTED_LOCALE_STORAGE_KEY = 'atemoya-app:selected-locale';
export const SELECTED_GAME_LOCALE_STORAGE_KEY = 'atemoya-app:selected-game-locale';
